<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		created: function() {
		},
		watch:{
		}
	}
</script>

<style>
	html,
	body,
	#app {
		margin: 0;
		top: 0
	}

	.page {
	}
</style>
